export class ApiError extends Error {
  constructor(
    message: string,
    readonly status: number,
    readonly details?: unknown,
  ) {
    super(message);
    this.name = "ApiError";
  }

  isTermsAcceptanceRequired(): boolean {
    if (this.status !== 403) return false;
    const d = this.details as { error?: string } | undefined;
    return d?.error === "TERMS_ACCEPTANCE_REQUIRED";
  }
}

export function isTermsAcceptanceRequiredError(error: unknown): boolean {
  if (error instanceof ApiError) {
    return error.isTermsAcceptanceRequired();
  }
  return false;
}


/** scheduledFor (ISO) quando o erro é o 403 ACCOUNT_PENDING_DELETION; senão null. */
export function pendingDeletionScheduledFor(error: unknown): string | null {
  if (!(error instanceof ApiError) || error.status !== 403) return null;
  // details é o corpo inteiro da resposta; a data fica em details.details.scheduledFor.
  const body = error.details as { error?: string; details?: { scheduledFor?: unknown } } | undefined;
  if (body?.error !== "ACCOUNT_PENDING_DELETION") return null;
  const scheduledFor = body.details?.scheduledFor;
  return typeof scheduledFor === "string" ? scheduledFor : null;
}
